type DailyCheckRow = {
  dateInput: string;
  verdict: string;
};

function localDateKey(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDailyBars(rows: DailyCheckRow[], days: number, today = new Date()) {
  const dateCounts = new Map<string, { total: number; bans: number }>();
  rows.forEach((row) => {
    if (!row.dateInput) {
      return;
    }
    const current = dateCounts.get(row.dateInput) || { total: 0, bans: 0 };
    current.total += 1;
    if (row.verdict === "ban") {
      current.bans += 1;
    }
    dateCounts.set(row.dateInput, current);
  });

  const periodDays = Math.max(1, Math.floor(days));
  const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const bars = Array.from({ length: periodDays }, (_, index) => {
    const date = new Date(endDate);
    date.setDate(endDate.getDate() - (periodDays - 1 - index));
    const key = localDateKey(date);
    const value = dateCounts.get(key) || { total: 0, bans: 0 };
    return {
      label: periodDays > 10 ? key.slice(5) : key.slice(8),
      total: value.total,
      bans: value.bans,
    };
  });
  const max = Math.max(1, ...bars.map((bar) => bar.total));
  return bars.map((bar) => ({
    ...bar,
    totalPercent: Math.max(bar.total ? 12 : 3, Math.round((bar.total / max) * 100)),
    banPercent: Math.max(bar.bans ? 12 : 3, Math.round((bar.bans / max) * 100)),
  }));
}
